import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestTemplatesServiceUseGet = {
    path: "/templates/services/:identifier",
    method: RouteHttpVerb.GET,
    obfuscatePath: "full"
};
export { locationRestTemplatesServiceUseGet };
